import { ComponentChildren } from 'preact';
import { Tabs, Tab } from '@components/tabs';

export function SettingsTabs({ currentTab }: { currentTab: 'settings' | 'domains' }) {
  return (
    <Tabs>
      <Tab href="/calendar/settings" isSelected={currentTab === 'settings'}>
        Profile & Settings
      </Tab>
      <Tab href="/calendar/domains" isSelected={currentTab === 'domains'}>
        Custom Domains
      </Tab>
    </Tabs>
  );
}

export function SectionHeading({ children }: { children: ComponentChildren }) {
  return <h2 class="font-semibold text-lg">{children}</h2>;
}
